export const submitFormMixin = {
  data: () => {
    return {
      formLoading: false,
      formError: [],
      formSubmitted: false,
      formCreate: true,
      formReady: true,
    }
  },
  created() {
    const id = this.$route.params.id;

    if (id) {
      this.formData.id = id;
      this.formCreate = false;
      this.fetchData();
    }
  },
  computed: {
    submitUrl() {
      return this.formCreate ? "/" + this.$route.meta.endpoint : "/" + this.$route.meta.endpoint + "/" + this.formData.uuid;
    },
    fetchEndPoint() {
      return this.$route.meta.endpoint;
    },
    getRole() {
      return this.$store.getters.getRole;
    },
  },
  methods: {
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId)
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data
            this.formData = { ...this.formData, ...data };
            this.formReady = true;
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => { });
    },
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;
        this.$store.commit("toggleLoading");

        const method = this.formCreate ? "post" : "patch";
        const url = process.env.VUE_APP_API_URL + this.submitUrl;

        this.$http({
          method: method,
          url: url,
          data: this.formData,
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$router.push({ name: this.$route.meta.baseRoute }, () => {
                this.$swal({
                  position: 'bottom-end',
                  showConfirmButton: false,
                  toast: true,
                  timer: 5000,
                  timerProgressBar: true,
                  title: res.data.message,
                  icon: 'success'
                })
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                // this.formError[0] = error.response.data;
              } else {
                const { data } = error.response.data
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
  }
};